// Words read aloud but not shown: a label an icon or a colour dot already says on screen ("Goal: ", "Dream: ").
export const visuallyHidden = { position: "absolute", width: 1, height: 1, margin: -1, padding: 0, border: 0, overflow: "hidden", clip: "rect(0 0 0 0)", clipPath: "inset(50%)", whiteSpace: "nowrap" };
